import { Trans } from "react-i18next";
import { SignIn } from "../../components/auth/SignIn";
import { LanguageSwitcher } from "../../components/languageSwitcher/languageSwitcher";
import "./SignInPage.sass";

export const SignInPage = () => {
  return (
    <section className="sign-in-page">
      <div className="sign-in-page__panel">
        <div className="sign-in-page__lang">
          <LanguageSwitcher showButtons={false} />
        </div>

        <div className="sign-in-page__header">
          <p className="sign-in-page__eyebrow">B2B Portal</p>
          <h1 className="sign-in-page__title">
            <Trans i18nKey="signIn" />
          </h1>
        </div>

        <SignIn />
      </div>
    </section>
  );
};
